module.exports = __webpack_public_path__ + "img/duration.07d7d0fd.svg";